import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';

import * as actions from '../actions';
import * as actionCreators from '../action-creators';
import { mergeMap, withLatestFrom, filter } from 'rxjs/operators';
import { Actions } from '../../actions';
import * as user from '@webapp/sdk/users';
import AppState from '@webapp/store/state';
import { NewSubAccount } from '@services/user/types/new-sub-account';
import AdditionalAccount from '../../../../../../common/types/data/additional-account';

export const createAdditionalAccountEpic = (
  action$: Observable<Actions>,
  $state: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, actionCreators.CreateAdditionalAccount>(
      actions.CREATE_ADDITIONAL_ACCOUNT
    ),
    withLatestFrom($state),
    filter(([_, state]) => !!state.user.newAccount?.address),
    mergeMap(async ([action, state]) => {
      try {
        const prevAccounts = [
          ...(state.user.profile?.additionalEmails ?? []),
          ...(state.user.profile?.additionalTelephones ?? []),
        ];

        const newAccount = state.user.newAccount;

        if (
          !newAccount?.address ||
          isSameAsMainAccount(state.auth.user.attributes, newAccount) ||
          existsAsAdditional(prevAccounts, newAccount)
        ) {
          return new actionCreators.CreateAdditionalAccountError(
            'Address already exists'
          );
        }

        if (!action.password) {
          return new actionCreators.CreateAdditionalAccountError(
            'Password Required'
          );
        }

        const account = await user.addSubAccount(newAccount, action.password);

        return new actionCreators.CreateAdditionalAccountSuccess(account);
      } catch (err) {
        return new actionCreators.CreateAdditionalAccountError(
          (err as Error).message
        );
      }
    })
  );

const isSameAsMainAccount = (
  attributes: Record<string, string>,
  newAccount: NewSubAccount
) => {
  if (newAccount.type === 'phone') {
    return attributes.phone_number === newAccount.address;
  }
  if (!attributes) {
    return;
  }
  return attributes.email === newAccount.address;
};

const existsAsAdditional = (
  additionalAccounts: AdditionalAccount[],
  newAccount: NewSubAccount
) => {
  return additionalAccounts.some((a) => a.value === newAccount.address);
};
